import { Component, OnInit, OnDestroy } from "@angular/core";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Post } from "src/app/models/post";
import { DatePipe } from "@angular/common";
import { BlogService } from "src/app/services/blog.service";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { AppUser } from "src/app/models/appuser";
import { AuthService } from "src/app/services/auth.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-blog-editor",
  templateUrl: "./blog-editor.component.html",
  styleUrls: ["./blog-editor.component.scss"],
  providers: [DatePipe],
})
export class BlogEditorComponent implements OnInit, OnDestroy {
  public Editor = ClassicEditor;
  ckeConfig: any;
  postData = new Post();
  formTitle = "Add";
  postId;
  quiz:string;
  appUser: AppUser;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private blogService: BlogService,
    private router: Router,
    private authService: AuthService
  ) {
    this.route.paramMap
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((params: ParamMap) => {
        this.postId = params.get("id");
        this.quiz = params.get("quiz");
      });
  }

  ngOnInit() {
    this.authService.appUser$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((appUser) => (this.appUser = appUser));

    this.setEditorConfig();
    if (this.postId) {
      this.formTitle = "Edit";
      this.blogService
        .getPostbyId(this.postId, this.quiz)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((result) => {
          this.setPostFormData(result);
        });
    }
    else {
        this.postData.content = '<figure class="image"><img src="https://factofacts.com/wp-content/uploads/2020/10/image.png" alt="Amazon Quiz"><figcaption><a href="https://www.amazon.in/b?ie=UTF8&amp;node=14351766031&amp;tag=cuelinkss25719-21&amp;ascsubtag=20221005clsbpk3d9d8v">Start Quiz</a></figcaption></figure><figure class="image"><img src="https://factofacts.com/wp-content/uploads/2021/03/tele_factofacts.png" alt=""></figure><h2><strong>How to Play Amazon Quiz Today?</strong></h2><p>1) You can play quiz only on&nbsp;<strong>Amazon App</strong>, so you have to download &amp; install the&nbsp;<strong>Amazon Android</strong>&nbsp;or&nbsp;<strong>iOS app</strong>&nbsp;from Google Play Store or Apple’s App Store.</p><p>2) Open Amazon App &amp; Sign in into your Amazon Account with registered Email and Password (Create an account if you do not have an existing Amazon account)</p><p>&nbsp;</p><p>3) Now go to the Amazon Quiz page by clicking on the</p><p><strong>Menu&nbsp;&gt; Program &amp; Features &gt;&nbsp;FunZone</strong></p><p>4) Now just click the quiz which you want to complete by tapping the “Start” Button</p><p>5) You have to answer the all questions correctly in the Daily Amazon Quiz in order to be eligible to win exciting prizes</p><p>6) After answering all questions correctly of the quiz, you will be eligible for the Amazon Quiz winners’ lucky draw.</p><p>7) The Amazon Quiz lucky draw winners are announced on the winners list declaration date.</p>'
    }
  }
  setPostFormData(postFormData) {
    this.postData.title = postFormData.title;
    this.postData.content = postFormData.content;
    this.postData.imageUrl = postFormData.imageUrl;
    this.postData.videoId = postFormData.videoId;
    this.postData.quiz = postFormData.quiz;
    this.postData.createdDate = postFormData.createdDate
    }

  saveBlogPost() {
    console.log(this.postData, "POSTDATA");
    if (this.postId) {
      this.postData.updatedDate = this.datePipe.transform(
        Date.now(),
        "MM-dd-yyyy HH:mm"
      );
      
      this.blogService.updatePost(this.postId, this.postData).then(() => {
        this.router.navigate(["/quiz/" + this.findPage()]);
      });

    } else {
      this.postData.createdDate = this.datePipe.transform(
        Date.now(),
        "MM-dd-yyyy HH:mm"
      );
      this.postData.updatedDate = this.datePipe.transform(
        Date.now(),
        "MM-dd-yyyy HH:mm"
      );
      this.postData.author = this.appUser.name;
      this.blogService.createPost(this.postData).then(() => {
        this.router.navigate(["/quiz/" + this.findPage()]);
      });
    }
  }

  setEditorConfig() {
    this.ckeConfig = {
      removePlugins: ["ImageUpload", "MediaEmbed", "EasyImage"],
      heading: {
        options: [
          {
            model: "paragraph",
            title: "Paragraph",
            class: "ck-heading_paragraph",
          },
          {
            model: "heading1",
            view: "h1",
            title: "Heading 1",
            class: "ck-heading_heading1",
          },
          {
            model: "heading2",
            view: "h2",
            title: "Heading 2",
            class: "ck-heading_heading2",
          },
          {
            model: "heading3",
            view: "h3",
            title: "Heading 3",
            class: "ck-heading_heading3",
          },
          {
            model: "heading4",
            view: "h4",
            title: "Heading 4",
            class: "ck-heading_heading4",
          },
          {
            model: "heading5",
            view: "h5",
            title: "Heading 5",
            class: "ck-heading_heading5",
          },
          {
            model: "heading6",
            view: "h6",
            title: "Heading 6",
            class: "ck-heading_heading6",
          },
          { model: "Formatted", view: "pre", title: "Formatted" },
        ],
      },
    };
  }

  findPage() {
    return this.quiz == 'amazon' ? "Amazon" : "Flipkart";
  }

  cancel() {
    this.router.navigate(["/quiz/" + this.findPage()]);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
